import { render, staticRenderFns } from "./look_cooperation_offer.vue?vue&type=template&id=112aa80b&scoped=true"
import script from "./look_cooperation_offer.vue?vue&type=script&lang=js"
export * from "./look_cooperation_offer.vue?vue&type=script&lang=js"
import style0 from "./look_cooperation_offer.vue?vue&type=style&index=0&id=112aa80b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "112aa80b",
  null
  
)

export default component.exports